import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PageLink {
    title: string;
    url?: string;
}

interface FooterPageLinkProps {
    data: PageLink[];
    title?: string;
    titleShow?: boolean;
    viaNavigation?: boolean;
}

const FooterPageLink: React.FC<FooterPageLinkProps> = ({ data, title, titleShow = true, viaNavigation = false }) => {
    const navigate = useNavigate();
    return (
        <div>
            {titleShow ? (
                <p className="text-[#13974B] font-[WorkSans-Semibold] text-base mb-3 cursor-pointer transition-transform transform-gpu hover:scale-105 uppercase">
                    {title}
                </p>
            ) : null}
            {data.map((p) => (
                <p
                    className="font-[WorkSans] text-base mb-3 text-white cursor-pointer"
                    key={`${p.title}`}
                    onClick={() => {
                        if (p.url) {
                            viaNavigation ? navigate(p.url) : window.open(p.url);
                        }
                    }}
                >
                    {p.title}
                </p>
            ))}
        </div>
    );
};

export default FooterPageLink;
